import { FCSelector } from '../../model/form-config.interface';
import {
  CREDIT_PROVISION_EXCLUDED_OBLIGATIONS,
  CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST,
} from './product-capture-field-selectors.consts';

export const EXCLUDED_OBLIGATIONS: FCSelector = {
  formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST],
          readOnly: false,
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST],
          readOnly: true,
        },
        {
          formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST],
          selectValues: [[]],
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST],
          readOnly: true,
        },
        {
          formControlNames: [CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST],
          selectValues: [[]],
        },
      ],
    },
  ],
};
